<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { isAuthenticated, isLoading, hasAlpacaAccount } from "../stores/auth.js";
  
  export let requiresAlpaca = false;
  
  let mounted = false;
  
  function checkAccess() {
    if (!$isLoading) {
      if (!$isAuthenticated) {
        navigate('/auth/login', { replace: true });
      } else if (requiresAlpaca) {
        if (!$hasAlpacaAccount) {
          navigate('/admin/onboarding', { replace: true });
        }
      }
    }
  }
  
  // Handle redirects reactively
  $: if (mounted) {
    checkAccess();
  }
  
  onMount(() => {
    mounted = true;
    checkAccess();
  });
  
  $: needsAlpaca = requiresAlpaca;
  $: showContent = !$isLoading && $isAuthenticated && (!needsAlpaca || $hasAlpacaAccount);
</script>

{#if $isLoading}
  <div class="flex items-center justify-center min-h-screen bg-canvas">
    <div class="text-center">
      <i class="fas fa-spinner fa-spin text-2xl text-moira mb-3"></i>
      <p class="text-sm text-ink-secondary">Loading…</p>
    </div>
  </div>
{:else if !$isAuthenticated}
  <div class="flex items-center justify-center min-h-screen bg-canvas">
    <div class="text-center">
      <i class="fas fa-spinner fa-spin text-2xl text-moira mb-3"></i>
      <p class="text-sm text-ink-secondary">Redirecting to sign in…</p>
    </div>
  </div>
{:else if needsAlpaca && !$hasAlpacaAccount}
  <div class="flex items-center justify-center min-h-screen bg-canvas">
    <div class="text-center">
      <i class="fas fa-spinner fa-spin text-2xl text-moira mb-3"></i>
      <p class="text-sm text-ink-secondary">Redirecting to setup…</p>
    </div>
  </div>
{:else}
  <slot />
{/if}